import React from 'react';
import urlBase from '../../../url-base';
import Dialog from 'material-ui/Dialog';
import Grid from '@material-ui/core/Grid';
import Checkbox from 'material-ui/Checkbox';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Divider from 'material-ui/Divider';
import axios from 'axios';
import { Input, Alert } from 'reactstrap';
import InputMask from 'react-input-mask';
import CurrencyFormat from 'react-currency-format';
import PropTypes from 'prop-types';
import queryString from 'query-string';
//import { Button } from 'reactstrap';
import { Row, Col } from  'reactstrap';// 'fluid-react';
import moment from "moment";
import { Colors, Styles, tableStyles } from '../../../../src/styles/theme';
import { FaStepBackward } from "react-icons/fa";
import CircularProgress from 'material-ui/CircularProgress';


class List extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            titlePage: "",
            data: 'loading',
            modalOpen: false,
            detailsData: 'loading',
            details:{
                dependents:[],
                imagesDocs: { doc1: '', doc2: ''},
            },
            proposalsNumber: 'Carregando...',
            openModalInclusion:false,
            openModalRetornoValidacao:false,
            amountReceived:false,
            userType:'',
            stateList: [],
            addressTypeList: [],
            cityList: [],
            districtList: [],
            confirm: false,
            confirmCheck: false,
            errorCheck: false,
            confirmationCancel:false,
            confirmacaoRetornoValidacao:false,
            confirmationS4E:false,
            cancellationsList: [],
            cancellationId:'',
            cancellationName:'',
            cancellation:'',
            sendCancelation:false,
            sendReenvioValidacao:false,
            where: '',
            inclusion:'',
            showData:false,
            showColBroker: false,
            showColSalesman: false,
            openDetails:false,
            holder:'',
            currentTimeServer: null,
            listYear: [],
            showFirstPayment: false,
            disabledInput: true,
            disabledInputValuePlan: true,
            disabledInputHolder: true,
            showFieldContactCustomer: false,
            contactCustomerTemp: '',
            showTable: false,
            analyzingSalesId: '',
            toggleChecked: false,
            colorBackImg: '#fff',
            errorRequest: false,
            confirmFmMensage: '',
            globalInterval: null,
            salesId: '',
            status:''
        };

        this.styles = {
            table: {
                tableConfig: {
                    ontFamily: "RubikRegular",
                    textTransform: "uppercase",
                },
                theadTr: {
                    fontFamily: "RubikRegular",
                    textTransform: "uppercase",
                }
            },
            error: {
                textAlign: 'center',
                fontSize: 18,
                color: '#ea0000',
                background: '#fff',
                padding: 10,
                borderRadius: 3,
                fontWeight: 500
            },
            zero: {
                textAlign: 'center',
                fontSize: 18,
                background: '#fff',
                padding: 10,
                borderRadius: 3,
                fontWeight: 500
            },
            modal: {
                width: '85%',
                maxWidth: 'none',
            },
            fieldset: {
                border: '1px solid #f5aa00',
                padding: 10,
                marginTop: 15,
                paddingBottom: 25,
                borderRadius: 5
            },
            legend: {
                width: 'auto',
                fontSize: 20,
                position: 'relative',
                marginLeft: 15,
                padding: '0 5px'
            },
            input: {
                width: '100%'
            },
            label: {
                margin: 0
            },
            col: {
                marginTop: 0,
                paddingBottom: 0
            },
            doc: {
                width: 150,
                height: 100,
                padding: '.25rem',
                backgroundColor: '#fff',
                border: '1px solid #dee2e6',
                borderRadius: '.25rem',
                cursor: 'pointer'
            },
            docPdf: {
                width: 150,
                height: 100,
                padding: '.25rem',
                backgroundColor: '#fff',
                cursor: 'pointer',
                marginTop: 5
            },
            titleDoc: {
                margin: 0
            },
            closeBtn: {
                float: 'right',
                width: 25,
                cursor: 'pointer',
                position: 'relative',
                bottom: 15,
                left: 5
            },
            penEdit: {
                cursor: 'pointer',
                padding: 10
            }
        };
    }

    componentWillMount() {        
        this.getProposals();
    }

    reenviarEmail($id) {
        let dataSend = {
          id: $id
        };
    
        axios.post(urlBase.loopBack + 'Inclusions/reenviarEmail', dataSend)
          .then(() => {
            alert("O e-mail de confirmação foi reenviado para o cliente. Atenção: Peça para o cliente verificar a caixa de spam ou promoções, caso ele não tenha recebido.");
    
          })
          .catch(function (error) {
            alert("Erro ao reenviar Email: " + error);
          }.bind(this));
    }

    getProposals(){

        let userType = localStorage.getItem('dental_y');
        this.state.userType = userType;
        let state = this.state;
        let utils = this;
        let param = queryString.parse(window.location.search);
        let filter = '';

        switch (param.search) {
            case "pendente":
                filter = 'PAGAMENTO PENDENTE';                
                break;
            case "em-validacao":
                filter = 'EM VALIDAÇÃO';
                break;
            case "ativo":
                filter = 'ATIVO';
                break;
            case "cancelado":
                filter = 'CANCELADO';
                break;
        }

        state.status= filter;

        // perfil cadastro ou admin
        if (userType != 'SALESMAN' && userType != 'BROKER') {
            this.state.where = 'Inclusions?filter={"where":{"status":"' + filter + '"},"include":["broker","user","salesman"]}';
            state.showColBroker = true;
        } else {
            state.showColBroker = false;
        }

        if (userType == 'BROKER') {
            this.state.where = 'Inclusions?filter={"where":{"brokerId":"' + localStorage.getItem('dental_u') + '","status":"' + filter + '"},"include":["broker","user","salesman"]}';
            state.showColBroker = true;
        }

        if (userType == 'SALESMAN') {
            this.state.where = 'Inclusions?filter={"where":{"salesmanId":"' + localStorage.getItem('dental_u') + '","status":"' + filter + '"},"include":["broker","user","salesman"]}';
            state.showColSalesman = false;
            // Permite edição de campos do resumo da proposta
        } else {
            state.showColSalesman = true;
        }

        // Pega a lista de tipos de endereço
        this.state.loading = true,
        utils.setState(state);
        // paulo list
        axios.get(urlBase.loopBack + this.state.where)
            .then((result) => {
                utils.setState({ data: result.data })
                utils.setState({ showData: true })
                $(document).ready(function () {
                    $('#table_id').DataTable({
                        "language": {
                            "url": urlBase.client + "assets/plugins/datatables/Portuguese-Brasil.lang"
                        },
                        "order": [[0, "desc"]],
                        lengthMenu: [
                            [10, 25, 50, 100, -1],
                            ['10', '25', '50', 100, 'Todas']
                        ],
                        columnDefs: [
                            { className: 'mdl-data-table__cell--non-numeric' },
                            { type: 'date-uk', targets: 0 },
                        ]
                    });
                });
            

            })
            .catch(function (error) {
                console.log(error);
                //alert('Não foi possível carregar a lista de inclusões')
                utils.setState({ showData: false });
            });


        axios.get(urlBase.loopBack + 'Cancellations')
            .then((result) => {
                utils.setState({ cancellationsList: result.data })
            })
            .catch(function () {
                //alert('Não foi possível carregar a lista cancelamentos')
                utils.setState({ showData: false });
            });


        this.getUfs();

    }

    hideData(){
        this.setState({ showData: false });
    }

    getCancellation($id){
        
        axios.get(urlBase.loopBack + 'Cancellations/' + $id)
            .then((result) => {               
                this.setState({ cancellation: result.data })                
            })
            .catch(function () {
                alert('Não foi possível carregar o motivo do cancelamento!')                
            });
    }

    handleModalCloseInclusion(){
        this.setState({ openModalInclusion: false })         
    }
    handleModalCloseRetornoValidacao(){
        this.setState({ openModalRetornoValidacao: false })         
    }
    adicionaZero(numero) {
        if (numero <= 9)
            return "0" + numero;
        else
            return numero;
    }

    getDetails($id){
        axios.get(urlBase.loopBack + 'Inclusions/'+$id)
        .then((result) => {
            let dataAtual = new Date(result.data.created);
            result.data.created = (this.adicionaZero(dataAtual.getDate().toString()) + "/" + (this.adicionaZero(dataAtual.getMonth() + 1).toString()) + "/" + dataAtual.getFullYear());
            
            if(result.data.status=="CANCELADO"){
                this.getCancellation(result.data.cancellationId);
            }

            if (result.data.salesmanConfirm !=null) {
                let dataConfirm = new Date(result.data.salesmanConfirm);
                result.data.salesmanConfirm = (this.adicionaZero(dataConfirm.getDate().toString()) + "/" + (this.adicionaZero(dataConfirm.getMonth() + 1).toString()) + "/" + dataConfirm.getFullYear());
                
                this.setState({ confirmCheck: true })
                this.setState({ confirm: true })                
            }else{
                this.setState({ confirmCheck: false })
                this.setState({ confirm: false })                
            }

            if(this.state.details.confirmationDate!=''){
                let dataConfirm = new Date(result.data.confirmationDate);
                result.data.confirmationDate = (this.adicionaZero(dataConfirm.getDate().toString()) + "/" + (this.adicionaZero(dataConfirm.getMonth() + 1).toString()) + "/" + dataConfirm.getFullYear());
            }

            this.setState({ details: result.data })                           
            this.searchHolder(result.data.cpfHolder, result.data.holderId);

        })
        .catch(function () {
            alert('Não foi possível carregar a lista de inclusões')
            this.setState({ showData: false });
        });
    }

    getUfs(){

        axios.get(urlBase.loopBack + 'APIS4s/UFs')
        .then((result) => {
            this.setState({ stateList: result.data});
            this.setState({ showData: true });
            
        }).catch(function () {
            alert('Não foi possível carregar a lista de inclusões')
            this.setState({ showData: false });
        });    

    }

    searchHolder(cpf, codigo){
        let url = urlBase.loopBack + 'APIS4s/Associados';
        let dataPost = {
            cpf: cpf
        };

        axios.post(url, dataPost)
        .then((result) => {
                var lista = result.data;
                var itemEncontrado = lista.find(function(item) {
                    return item.codigo === Number(codigo);
                });
                console.dir(itemEncontrado)
                if (itemEncontrado) {
                    this.setState({ holder: itemEncontrado});            
                    this.setState({ openModalInclusion: true }) 
                } else {
                    // Opcional: tratar caso o código não exista no array
                    console.log("Item não encontrado");
                }            

        })
        .catch(function () {
            //alert(erro);
        });    
    }

    confirmCheck() {
        this.setState((oldState) => {
            let state = oldState;
            state.confirmCheck = !state.confirmCheck;
            return state;
        });
    }
    
    confirmReceiveAmount($id){
        // Tratando aqui do envio para o S4 via vendedor
        let url = "";
        if (this.state.details.planPJ == true) {
            url = urlBase.loopBack + 'Inclusions/amountReceived';
        } else {
            if (this.state.details.empresaPublica == "false" 
                || this.state.details.empresaPublica == false 
                || this.state.details.empresaPublica == undefined
                || this.state.details.empresaPublica == ""
                || this.state.details.empresaPublica == null
            ) {
                url = urlBase.loopBack + 'Inclusions/sendToS4E';
            } else {
                url = urlBase.loopBack + 'Inclusions/amountReceived';                

            }
        }    

        let dataPost = {
            id: $id
        };

        axios.post(url, dataPost)
        .then(() => {            
            this.confirmCheck();
            this.handleModalCloseInclusion();            
            alert('Proposta atualizada com sucesso!');
            location.reload();

        })
        .catch(function () {
            alert('Não foi possível atualizar a proposta, entre em contato com o suporte');
        });    

    }

    amountReceived($id){
        if (this.state.details.confirmationDate == null || this.state.details.confirmationDate =='' || this.state.details.confirmationDate =='NaN/NaN/NaN' ) {
            alert('Não é possível confirmar o recebimento. A proposta ainda não foi confirmada pelo cliente!');
            return;
        }

        if (this.state.confirmCheck){
            this.confirmReceiveAmount($id);
        }else{
            alert('Marque a caixa de seleção primeira parcela!')
        }   

    }

    closeInclusion(){
        this.setState({ confirmationCancel:false});
    }

    handleCloseConfirm(){
        this.setState({ confirmationCancel: true });
    }

    closeConfirmRetornoValidacao(){
        this.setState({ confirmacaoRetornoValidacao:false});
    }    
    handleCloseConfirmRetornoValidacao(){
        this.setState({ confirmacaoRetornoValidacao: true });
    }

    chooseCancelation($id){
        this.setState({ cancellationId: $id });
        let state = this.state;
        state.cancellationId = document.getElementById($id).value;
        let sel = document.getElementById($id);
        state.cancellationName = sel.options[sel.selectedIndex].text;
        this.setState(state);
    }

    cancelarInclusao(){
        
        if (this.state.cancellationId == "" || this.state.cancellationId==undefined){
            alert('Selecione o motivo do cancelamento');
            return false;
        }

        this.setState({ sendCancelation: true });

        let url = urlBase.loopBack + 'Inclusions/cancelationInclusion';
        let dataPost = {
            id: this.state.details.id,
            cancellationId: this.state.cancellationId,
            cancellationName: this.state.cancellationName
        };

        axios.post(url, dataPost)
        .then(() => {            
            this.closeInclusion();
            this.handleModalCloseInclusion();
            this.getProposals();
            alert('Proposta atualizada com sucesso!');
            location.reload();
            this.setState({ sendCancelation: false });

        })
        .catch(function () {
            //alert(erro);
        });    

    }
    retornarParaValidacao(){

        this.setState({ sendReenvioValidacao: true });

        let url = urlBase.loopBack + 'Inclusions/retornaParaValidacao';
        let dataPost = {
            id: this.state.details.id
        };

        axios.post(url, dataPost)
        .then(() => {            
            this.closeConfirmRetornoValidacao();
            this.handleModalCloseRetornoValidacao();
            this.getProposals();
            alert('Proposta reenviada com sucesso!');
            location.reload();
            this.setState({ sendReenvioValidacao: false });

        })
        .catch((error) => {
            console.log('ERRO COMPLETO:', error);
            if (error.response) {
            console.log('STATUS:', error.response.status);
            console.log('DA*A:', error.response.data);
            }
            this.setState({ sendReenvioValiacao: false });
            });   

    }

    sendToS4EModal(){
        this.setState({ confirmationS4E:true});
    }

    closeS4E(){
        this.setState({ confirmationS4E: false });
    }

    sendToS4E($id){
        let url = urlBase.loopBack + 'Inclusions/sendToS4E';
        let util = this;
        let dataPost = {
            id: $id
        };
        this.handleModalCloseInclusion();
        this.sendToS4EModal();

        axios.post(url, dataPost)
        .then(() => {            
            this.closeS4E();
            alert('Proposta atualizada com sucesso!');
            location.reload();
        }).catch((reason) => {
            util.closeS4E();  
            alert('Não foi possível atualizar a proposta, entre em contato com o suporte e informe o erro: '+ reason);
        });
      /*  
              }).catch(onrejected);
      
      .catch(function () {
            alert('Não foi possível atualizar a proposta, entre em contato com o suporte');
            util.closeS4E();
        });

        function onrejected(reason) {
            util.closeS4E();  
            alert('Não foi possível atualizar a proposta, entre em contato com o suporte e informe o erro: '+ reason);
        }
*/
    }

    openWindow(image, title) {
        
        let url =''
        if (image.substr(image.length - 3, image.length).toLowerCase() == 'pdf'){
            url = urlBase.loopBack + 'attachments/docs/download/' + image;
        }else{
            url = urlBase.client + 'spinimage?im=' + image;
        }        

        window.open(
            url,
            title,
            "location,status,scrollbars,resizable,width=800, height=800"
        );
    }
	goBack(){
        window.history.back();
    }
    render() {

        return (

            <div id="resume_content">
                <style>{tableStyles}</style>
                
                <style>{`
                        #resume_content a {
                            color: inherit;
                        }
                        #resume_content a:hover {
                            text-decoration: none;
                        }
                `}</style>                
                            <Row>
                                <Col xs="12" sm="12" md="3" lg="3" xl="3">
                                    <p onClick={this.goBack.bind(this)} style={{cursor:'pointer'}}> <FaStepBackward/>  Voltar</p>
                                </Col>
                                <Col xs="12" sm="12" md="3" lg="3" xl="3">
                                </Col>
                                
                                <Col xs="12" sm="12" md="3" lg="3" xl="3">
                                
                                </Col>                            
                            </Row>
                

                    <Alert color='success' id="alert_wallet_cpf" style={{ fontSize: 13 }} >STATUS DAS INCLUSÕES: <b>{this.state.status}</b></Alert>

{(() => {
  var data = this.state.data;

  // 1. ESTADO DE CARREGAMENTO (Essencial ser o primeiro)
  if (data === 'loading') {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <CircularProgress />
        <p style={{ color: Colors.textLight, marginTop: '10px' }}>Carregando dados...</p>
      </div>
    );
  }

  // 2. ESTADO DE ERRO
  if (data === 'error') {
    return (
      <div style={{ padding: '20px' }}>
        <Alert color='danger'>Erro ao conectar com o servidor. Verifique sua conexão.</Alert>
      </div>
    );
  }

  // 3. VERIFICAÇÃO DE DADOS REAIS
  // Se não for array ou for array vazio após o loading ter saído
  if (!Array.isArray(data) || data.length === 0) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <Alert color='warning' style={{ fontSize: 13 }}>
          Nenhuma informação encontrada.
        </Alert>
      </div>
    );
  }

  // 4. RENDERIZAÇÃO DA TABELA (3725 itens detectados no seu log!)
  return (
    <div style={{ width: '100%' }}>
      
<table
  style={{ width: '100%' }}
  id="table_id"
  className="mdl-data-table table-striped dataTable"
>

        <thead>
          <tr style={this.styles.table.theadTr}>
            <th style={{ width: 85 }}>Data</th>
            <th>Vendedor</th>    
            <th>Resp. Financeiro</th>
            <th>CPF</th>
            <th>Plano</th>
            <th>Vidas</th>
            <th>Valor</th>  
            <th>Situação</th>                                    

          </tr>
        </thead>
        <tbody>
          {data.map(function(item, index) {
            return (
              <tr
                key={index}
                className="row_table"
                onClick={this.getDetails.bind(this, item.id)}
                style={{ cursor: 'pointer' }}
              >                                                                
                <td data-label="Data">{moment(item.created).format('DD/MM/YYYY H:mm')}</td>
                <td data-label="Vendedor">{item.user ? item.user.name : 'S/V'}</td>
                <td data-label="Resp. Financeiro">{item.holder}</td>             
                <td data-label="CPF">{item.cpfHolder}</td>
                <td data-label="Plano">{item.planName}</td>
                <td data-label="Vidas">{item.qtyNewDependents}</td>
                <td data-label="Valor">{'R$ ' + item.totalValue}</td>
                <td data-label="Valor">{item.status}</td>

              </tr>
            );
          }.bind(this))}
        </tbody>
      </table>
    </div>
  );
})()}



                <Dialog
                    title={
                        <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '16px 24px',
                        backgroundColor: Colors.backgroundLight,
                        borderBottom: `1px solid ${Colors.borderLight}`,
                        borderRadius: '8px 8px 0 0'
                        }}>
                        <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                            {this.state.tituloDialog} Proposta de Inclusão de Dependente
                        </span>
                        <img
                            style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                            src={urlBase.client + '/assets/images/icons/icon_close.png'}
                            onClick={this.handleModalCloseInclusion.bind(this)}
                        />
                        </div>
                    }
                    titleStyle={{ padding: 0 }}
                    bodyStyle={{ padding: '24px' }}
                    modal={false}
                    open={this.state.openModalInclusion}
                    onRequestClose={this.handleModalCloseInclusion.bind(this)}
                    autoScrollBodyContent={true}
                    contentStyle={{ width: '90%', maxWidth: '1400px', borderRadius: '8px', overflow: 'hidden' }}
                    >                
       
                <fieldset style={this.styles.fieldset}>
                    <legend style={this.styles.legend}>
                        Forma de Confirmação
                    </legend>

                    <Grid container spacing={24}>
                        <Grid item style={this.styles.col} xs={12} sm={12} md={12} lg={12}>
                            <RadioButtonGroup
                                name="confirmation"
                                //onChange={this.confirmationForm.bind(this)}
                                    valueSelected={this.state.details.confirmationType}
                            >
                                <RadioButton
                                    value="VENDEDOR"
                                    label="Proposta Física"
                                    disabled={true}
                                />
                                <RadioButton
                                    value="EMAIL"
                                    label="Email"
                                    disabled={true}
                                />
                            </RadioButtonGroup>
                        </Grid>
                    </Grid>
                </fieldset>

                    <fieldset style={this.styles.fieldset}>
                        <legend style={this.styles.legend}>
                            Responsável financeiro
                        </legend>

                        <Grid container spacing={24}>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                                <label style={this.styles.label}>Nome</label>
                                <Input
                                    id="h_firstName"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.details.holder}
                                />
                            </Grid>
                           
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                <label style={this.styles.label}>CPF</label>
                                <InputMask
                                    id="h_cpf"
                                    style={this.styles.input}
                                    mask="999.999.999-99"
                                    className="form-control"
                                    type="tel"
                                    disabled
                                    defaultValue={this.state.holder.cpf}
                                />                                
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                <label style={this.styles.label}>Sexo</label>
                                <Input
                                    id="fm_gender"
                                    type="select"
                                    className="form-control"
                                    defaultValue={this.state.holder.sexo}
                                    disabled                                    
                                >
                                    <option value="F">Feminino</option>
                                    <option value="M">Masculino</option>
                                </Input>
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={3}>
                                   
                                { 
                                    this.state.details.emailHolder == null || this.state.details.emailHolder == ""  ? (
                                        [
                                        <label key="label-email"
                                            style={{fontSize: 18, fontWeight: 'bold', width: 300, color : '#a8243e'}}
                                            >*E-mail</label>,
                                        <Input
                                            id="fm_address"
                                            key="input-email"
                                            style={this.styles.input}
                                            type="text"
                                            disabled
                                            defaultValue='NÃO INFORMADO'                                        
                                        />
                                        ]
                                    )
                                    : (
                                        [
                                        <label key="label-email" style={this.styles.label}>E-mail</label>,
                                        <Input
                                            key="input-email"
                                            id="fm_address"
                                            style={this.styles.input}
                                            type="text"
                                            disabled
                                            defaultValue={this.state.details.emailHolder}                                         
                                        />  
                                    ]                                  
                                    )
                                }
                                
               
                            </Grid>  
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={2}>
                                <label style={this.styles.label}>Data de Nasc.</label>
                                <Input
                                    id="fm_dateOfBirth"
                                    style={this.styles.input}
                                    
                                    disabled
                                    defaultValue={
                                        this.state.holder.dataDeNascimento 
                                            ? new Date(this.state.holder.dataDeNascimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) 
                                            : ''
                                        }
                                    // defaultValue={this.state.details.financialManager.dateOfBirth}                                    
                                />
                            </Grid>

                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                <label style={this.styles.label}>RG</label>
                                <Input
                                    id="fm_rg"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.holder.rg}
                                    // defaultValue={this.state.details.financialManager.rg}                                    
                                />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                <label style={this.styles.label}>Org. Expedidor</label>
                                <Input
                                    id="fm_rgEmitter"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.holder.orgaoExpedidor}
                                    // defaultValue={this.state.details.financialManager.rgEmitter}                                    
                                />
                            </Grid>

                            
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={1}>
                                <label style={this.styles.label}>CEP
                                    <i
                                        id="loading_address"
                                        style={{ display: 'none', marginLeft: 10, width: 15 }}
                                        className="fa fa-spinner fa-spin">
                                        &nbsp;
                                    </i>
                                </label>
                                <InputMask
                                    id="fm_cep"
                                    style={this.styles.input}
                                    mask="99.999-999"
                                    className="form-control"
                                    type="text"
                                    disabled
                                    defaultValue={this.state.holder.cep}
                                />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                <label style={this.styles.label}>Tipo</label>
                                <Input
                                    id="fm_addressType"
                                    type="select"
                                    className="form-control"
                                     defaultValue={this.state.holder.tipoDeLogradouro}
                                    disabled                                        
                                >
                                    <option value="-1">Tipo</option>
                                    {this.state.addressTypeList.map((item, index) =>
                                        <option key={index} value={item.Id}>{item.Nome}</option>
                                    )}
                                </Input>
                            </Grid>
                          
                            <Grid item style={this.styles.col} xs={12} sm={12} md={5} lg={7}>
                                <label style={this.styles.label}>Endereço</label>
                                <Input
                                    id="fm_address"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.holder.logradouro}                                        
                                />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={1}>
                                <label style={this.styles.label}>Número</label>
                                <Input
                                    id="fm_addressNumber"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.holder.numero}
                                />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                <label style={this.styles.label}>Complemento</label>
                                <Input
                                    id="fm_addressComplement"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.holder.complemento}                                        
                                />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                <label style={this.styles.label}>Estado</label>
                                <Input
                                    id="fm_state"
                                    type="text"
                                    className="form-control"
                                    defaultValue={this.state.holder.ufSigla}
                                    disabled
                                >

                                </Input>
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                                <label style={this.styles.label}>Cidade</label>
                                <Input
                                    id="fm_city"
                                    type="text"
                                    className="form-control"
                                    defaultValue={this.state.holder.cidade}
                                    disabled
                                >

                                </Input>
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                                <label style={this.styles.label}>Bairro</label>
                                <Input
                                    id="fm_district"
                                    type="text"
                                    className="form-control"
                                    defaultValue={this.state.holder.bairro}
                                    disabled                                        
                                >

                                </Input>
                            </Grid>     
                            <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                                <label style={this.styles.label}>Empresa Pública</label>
                                <Input
                                    id="fm_empresa_publica"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={
                                                this.state.details.empresaPublica
                                                    ? "Sim"
                                                :  "Não"
                                                                   
                                    }                                        
                                />
                            </Grid>                                                             
                        </Grid>
                    </fieldset>        

                    <fieldset style={this.styles.fieldset}>
                        <legend style={this.styles.legend}>
                            Dependentes adicionados
                        </legend>
                        {
                            this.state.details.dependents.length == 0 ? (
                                <Grid container spacing={24}>
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        Não possui dependentes
                                            </Grid>
                                </Grid>
                            ) : (
                                    this.state.details.dependents.map((item, index) =>
                                        <Grid container spacing={24} key={index}>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                                                <label style={this.styles.label}>Nome</label>
                                                <Input
                                                    id={index + '_firstName'}
                                                    style={this.styles.input}
                                                    type="text"
                                                    disabled
                                                    defaultValue={item.firstName}
                                                />
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                                <label style={this.styles.label}>CPF</label>
                                                <InputMask
                                                    id={index + '_cpf'}
                                                    style={this.styles.input}
                                                    mask="999.999.999-99"
                                                    className="form-control"
                                                    type="tel"
                                                    disabled
                                                    defaultValue={item.cpf}
                                                />
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                                <label style={this.styles.label}>Data de Nasc.</label>
                                                <Input
                                                    id={index + '_dateOfBirth'}
                                                    style={this.styles.input}
                                                    type="date"
                                                    disabled
                                                    defaultValue={item.dateOfBirth}
                                                />
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={6} lg={6}>
                                                <label style={this.styles.label}>Nome da Mãe</label>
                                                <Input
                                                    id={index + '_motherName'}
                                                    style={this.styles.input}
                                                    type="text"
                                                    disabled
                                                    defaultValue={item.motherName}
                                                />
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                                <label style={this.styles.label}>Perentesco</label>
                                                <Input
                                                    id={index + '_parentage'}
                                                    type="select"
                                                    className="form-control"
                                                    defaultValue={item.parentage}
                                                    disabled
                                                >
                                                    <option value="CÔNJUGE">CÔNJUGE</option>
                                                    <option value="FILHO">FILHO</option>
                                                    <option value="PAI/MÃE">PAI/MÃE</option>
                                                    <option value="OUTRO">OUTRO</option>
                                                </Input>
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                                <label style={this.styles.label}>Sexo</label>
                                                <Input
                                                    id={index + '_gender'}
                                                    type="select"
                                                    className="form-control"
                                                    defaultValue={item.gender}
                                                    disabled
                                                >
                                                    <option value="0">Feminino</option>
                                                    <option value="1">Masculino</option>
                                                </Input>
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                                <label style={this.styles.label}>Estado Civil</label>
                                                <Input
                                                    id={index + '_maritalStatus'}
                                                    type="select"
                                                    className="form-control"
                                                    defaultValue={item.maritalStatus}
                                                    disabled
                                                >
                                                    <option value="SOLTEIRO">SOLTEIRO</option>
                                                    <option value="CASADO">CASADO</option>
                                                    <option value="VIÚVO">VIÚVO</option>
                                                    <option value="SEPARADO">SEPARADO</option>
                                                    <option value="DIVORCIADO">DIVORCIADO</option>
                                                    <option value="RELAÇÃO ESTÁVEL">RELAÇÃO ESTÁVEL</option>
                                                </Input>
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                                                <label style={this.styles.label}>Cartão SUS</label>
                                                <Input
                                                    id={index + '_susNumber'}
                                                    style={this.styles.input}
                                                    type="text"
                                                    disabled
                                                    defaultValue={item.susNumber}
                                                />
                                            </Grid>
                                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                                <label style={this.styles.label}>Valor</label>
                                                <CurrencyFormat
                                                    id={index + '_valuePlan'}
                                                    className="form-control"
                                                    style={this.styles.input}
                                                    type="tel"
                                                    thousandSeparator="."
                                                    prefix={'R$ '}
                                                    decimalScale={2}
                                                    decimalSeparator=","
                                                    disabled
                                                    value={item.planValue}
                                                />
                                            </Grid>

                                            {
                                                index + 1 < this.state.details.dependents.length ? (
                                                    <div style={{ width: '100%', margin: '15px 0px' }}>
                                                        <Divider
                                                            style={{ width: '100%', backgroundColor: 'rgb(245, 170, 0)' }}
                                                        />
                                                    </div>
                                                ) : ('')
                                            }
                                        </Grid>
                                    )
                                )
                        }
                    </fieldset>

                    <fieldset style={this.styles.fieldset}>
                        <legend style={this.styles.legend}>
                            Info. Plano
                    </legend>

                        <Grid container spacing={24}>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={4}>
                                <label style={this.styles.label}>Nome</label>
                                <Input style={this.styles.input} type="text" disabled
                                    defaultValue={this.state.details.planName} />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={2}>
                                <label style={this.styles.label}>Dia vencimento</label>
                                <Input 
                                    style={this.styles.input} 
                                    type="text" disabled
                                    defaultValue={this.state.details.dateFirstPayment} />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                <label style={this.styles.label}>Valor Total Inclusões</label>
                                <Input
                                    id="fm_responsibility"
                                    style={this.styles.input}
                                    type="text"
                                    disabled
                                    defaultValue={this.state.details.totalValue}
                                />
                            </Grid>
                            <Grid item style={this.styles.col} xs={12} sm={12} md={3} lg={3}>
                                <label style={this.styles.label}>Data de Adesão</label>
                                <Input style={this.styles.input} 
                                    type="text" disabled
                                    defaultValue={this.state.details.created} 
                                    />
                            </Grid>                           

                        </Grid>
                    </fieldset>

                    {/* Para a Primeira Parcela */
                        localStorage.getItem('dental_y') == 'SALESMAN' ? (
                            this.state.details.status != 'PENDENTE' ? (
                                <fieldset style={this.styles.fieldset}>
                                    <legend style={this.styles.legend}>
                                        Primeira Parcela
                                    </legend>
                                    <Grid container spacing={24}>
                                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                            &nbsp;
                                        </Grid>
                                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>

                                            {
                                                this.state.errorCheck ? (
                                                    <div style={{ color: 'rgb(244, 67, 54)', marginBottom: 15 }}>
                                                        Campo obrigatório.
                                                    </div>
                                                ) : ('')
                                            }

                                            {
                                                this.state.confirm == false ? (
                                                    <Checkbox
                                                        label={"Declaro que recebi do Responsável Financeiro o valor de R$ " + this.state.details.totalValue + " referente ao valor da inclusão do plano em"}
                                                        checked={this.state.confirmCheck}
                                                        onCheck={this.confirmCheck.bind(this)}
                                                        disabled={this.state.details.salesmanConfirm!=null}
                                                    />                                                    
                                                ) : (
                                                        this.state.confirmFmMensage.length > 0 ? (
                                                            this.state.confirmFmMensage
                                                        ) : ('Confirmação da primeira parcela realizada em '+this.state.details.salesmanConfirm)
                                                    )
                                            }
                                        </Grid>
                                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                            &nbsp;
                                        </Grid>
                                    </Grid>
                                </fieldset>
                            ) : ('')
                        ) : ('')
                    }

                    {this.state.details.confirmationType =='EMAIL'?(
                        <fieldset style={this.styles.fieldset}>
                            <legend style={this.styles.legend}>
                                Confirmação do cliente
                      </legend>

                            <Grid container spacing={24}>
                                <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                    &nbsp;
                                </Grid>
                                <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>
                                     {this.state.details.confirmationDate == 'NaN/NaN/NaN'  ?(
                                       'Aguardando confirmação do cliente'
                                    ) : (this.state.details.confirmationDate !='' ?(
                                         this.state.details.confirmationDate
                                    ): ('Aguardando confirmação do cliente')
                                    )}
                                    {/** 
                                    {this.state.details.confirmationDate !='' ?(
                                        this.state.details.confirmationDate
                                    ) : ('Aguardando confirmação do cliente')}
                                    */}
                                </Grid>
                                <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                    &nbsp;
                                </Grid>
                            </Grid>
                        </fieldset>
                    ):('')}

                    
                      <fieldset style={this.styles.fieldset}>
                            <legend style={this.styles.legend}>
                                Documentos Anexados
                            </legend>

                            <Grid container spacing={24}>
                                {this.state.details.imagesDocs.doc1!=''?(
                                    <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={1}>
                                        
                                        {this.state.details.imagesDocs.doc1.substr(this.state.details.imagesDocs.doc1.length - 3, this.state.details.imagesDocs.doc1.length).toLowerCase() == 'pdf' ? (
                                            <span>                                                
                                                <i
                                                    className="far fa-file-pdf fa-6x"
                                                    style={{ ...this.styles.docPdf, backgroundColor: this.state.colorBackImg }}
                                                    onClick={this.openWindow.bind(this, this.state.details.imagesDocs.doc1, 'Confirmação')}
                                                >
                                                </i>
                                            </span>
                                        ) : (
                                            <img
                                                onClick={this.openWindow.bind(this, this.state.details.imagesDocs.doc1, 'Confirmação')}
                                                style={this.styles.doc}
                                                src={urlBase.loopBack + 'attachments/docs/download/' + this.state.details.imagesDocs.doc1}
                                            />
                                        )}                                        
                                    </Grid>
                                ):('')}
                            <Grid item style={this.styles.col} xs={12} sm={12} md={2} lg={1}>                                
                                </Grid>
                            {this.state.details.imagesDocs.doc2.substr(this.state.details.imagesDocs.doc2.length - 3, this.state.details.imagesDocs.doc2.length).toLowerCase() == 'pdf' && this.state.details.imagesDocs.doc2 != '' ? (
                                        <span> 
                                            <div style={{height:12}}></div>
                                            <i
                                                className="far fa-file-pdf fa-6x"
                                                style={{ ...this.styles.docPdf, backgroundColor: this.state.colorBackImg }}
                                                onClick={this.openWindow.bind(this, this.state.details.imagesDocs.doc2, 'Confirmação')}
                                            >
                                                        </i>
                                        </span>
                                    ) : ('')}

                            {this.state.details.imagesDocs.doc2.substr(this.state.details.imagesDocs.doc2.length - 3, this.state.details.imagesDocs.doc2.length).toLowerCase() != 'pdf' && this.state.details.imagesDocs.doc2 != '' ? (
                                <img
                                    onClick={this.openWindow.bind(this, this.state.details.imagesDocs.doc2, 'Confirmação')}
                                    style={this.styles.doc}
                                    src={urlBase.loopBack + 'attachments/docs/download/' + this.state.details.imagesDocs.doc2}
                                />
                            ) : ('')}


                                <Grid item style={this.styles.col} xs={12} sm={12} md={4} lg={1}>
                                    &nbsp;
                                </Grid>
                            </Grid>
                        </fieldset>
                    
                    

                    {/* Para a Primeira Parcela */
                        localStorage.getItem('dental_y') == 'SALESMAN' ? (
                            this.state.details.status == 'CANCELADO' ? (
                                <fieldset style={this.styles.fieldset}>
                                    <legend style={this.styles.legend}>
                                        Motivo do cancelamento:
                                    </legend>
                                    <Grid container spacing={24}>
                                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                            &nbsp;
                                        </Grid>
                                        <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>
                                            {this.state.cancellation.name}
                                        </Grid>
                                        <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                            &nbsp;
                                        </Grid>
                                    </Grid>
                                </fieldset>
                            ) : ('')
                        ) : ('')
                    }    
                    
                &nbsp;
                <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                         <button
                                    type="button"
                                    onClick={this.handleModalCloseInclusion.bind(this)}
                                    style={{ 
                                    ...Styles.buttonCancel, 
                                    backgroundColor: Colors.textLight, // Usando cinza para cancelar
                                    textTransform: 'none' 
                                    }}
                                >
                                    Fechar Formulário
                        </button>                     
                {!this.state.details.salesmanConfirmCheck && this.state.details.status !== 'CANCELADO' 
                && this.state.details.status !== 'ATIVO' ? (
                [
                    <button
                    key="cancelar"
                    type="button"
                    onClick={this.handleCloseConfirm.bind(this)}
                    style={{
                        ...Styles.buttonCancel,
                        backgroundColor: Colors.textLight,
                        textTransform: 'none'
                    }}
                    >
                    Cancelar Inclusão
                    </button>,
                    localStorage.getItem('dental_y') === 'SALESMAN' ? (
                    <button
                        key="recebi"
                        type="button"
                        onClick={this.amountReceived.bind(this, this.state.details.id)}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}
                    >
                        Recebi o Valor da Inclusão
                    </button>
                    ) : null,

                    this.state.details.status === 'PAGAMENTO PENDENTE' ? (
                    <button
                        key="reenviar"
                        type="button"
                        onClick={this.reenviarEmail.bind(this, this.state.details.id)}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}
                    >
                        Reenviar E-mail
                    </button>
                    ) : null
                ]
                ) : null}
                {this.state.details.status === 'EM VALIDAÇÃO' ? (
                [
                    <button
                    key="cancelar"
                    type="button"
                    onClick={this.handleCloseConfirm.bind(this)}
                    style={{
                        ...Styles.buttonCancel,
                        backgroundColor: Colors.textLight,
                        textTransform: 'none'
                    }}
                    >
                    Cancelar Inclusão
                    </button>,

                    localStorage.getItem('dental_y') !== 'SALESMAN' &&
                    localStorage.getItem('dental_y') !== 'BROKER' ? (
                    <button
                        key="enviarS4"
                        type="button"
                        onClick={this.sendToS4E.bind(this, this.state.details.id)}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}
                    >
                        Enviar para o S4
                    </button>
                    ) : null
                ]
                ) : null}
                {/**pAULO */}
                {
                localStorage.getItem('dental_y') === 'REGISTER' && this.state.details.status === 'ATIVO' ? (
                    <button
                        key="recebi"
                        type="button"
                        onClick={this.handleCloseConfirmRetornoValidacao.bind(this)}
                        style={{
                        ...Styles.buttonSuccess,
                        fontWeight: 'bold',
                        textTransform: 'none'
                        }}
                    >
                        Retornar para validação
                    </button>
                    ) : null
                } 
                </div>
           
                      
                </Dialog> 
                {/** Reenviar para validação */}
                <Dialog
                        title={
                            <div 
                                style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '16px 24px',
                                backgroundColor: Colors.backgroundLight,
                                borderBottom: `1px solid ${Colors.borderLight}`,
                                borderRadius: '8px 8px 0 0'
                                }}>
                                <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                                    {this.state.tituloDialog} Reenvio para validação
                                </span>
                                <img
                                    style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                                    src={urlBase.client + '/assets/images/icons/icon_close.png'}
                                    onClick={this.closeConfirmRetornoValidacao.bind(this)}
                                />
                            </div>
                            }
                            titleStyle={{ padding: 0 }}
                            bodyStyle={{ padding: '24px' }}
                            modal={false}
                            contentStyle={{ width: '90%', maxWidth: '700px', borderRadius: '8px', overflow: 'hidden' }}                
                            open={this.state.confirmacaoRetornoValidacao}
                            onRequestClose={this.closeConfirmRetornoValidacao.bind(this)}
                        >                    
                        {!this.state.sendReenvioValidacao ? (
                        <div>
                                <p className="modal_title">CONFIRMA?</p>

                                    <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                        <button
                                            type="button"
                                            onClick={this.closeConfirmRetornoValidacao.bind(this)}
                                            style={{ 
                                            ...Styles.buttonCancel, 
                                            backgroundColor: Colors.textLight, // Usando cinza para cancelar
                                            textTransform: 'none' 
                                            }}
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            type="button"
                                            onClick={this.retornarParaValidacao.bind(this)}
                                            style={{ 
                                            ...Styles.buttonSuccess, 
                                            fontWeight: 'bold', 
                                            textTransform: 'none' 
                                            }}
                                        >
                                            Sim
                                        </button>
                                    </div>                            

                        </div>
                        ):(
                                <div className="modal_error_text">
                                    Estamos atualizando sua proposta aguarde....!
                                </div>
                        )}

                </Dialog>
                {/** Cancelar */}
                <Dialog
                        title={
                            <div 
                                style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '16px 24px',
                                backgroundColor: Colors.backgroundLight,
                                borderBottom: `1px solid ${Colors.borderLight}`,
                                borderRadius: '8px 8px 0 0'
                                }}>
                                <span style={{ fontSize: '1.2rem', fontWeight: 600, color: Colors.textDark, textTransform: 'uppercase' }}>
                                    {this.state.tituloDialog} Confirmação de Cancelamento
                                </span>
                                <img
                                    style={{ cursor: 'pointer', width: '16px', opacity: 0.5 }}
                                    src={urlBase.client + '/assets/images/icons/icon_close.png'}
                                    onClick={this.closeInclusion.bind(this)}
                                />
                            </div>
                        }
                        titleStyle={{ padding: 0 }}
                        bodyStyle={{ padding: '24px' }}
                        modal={false}
                        contentStyle={{ width: '90%', maxWidth: '700px', borderRadius: '8px', overflow: 'hidden' }}                
                        open={this.state.confirmationCancel}
                        onRequestClose={this.closeInclusion.bind(this)}
                >                    
                        {!this.state.sendCancelation ? (
                        <div>
                                <p className="modal_title">CONFIRMA?</p>
                                <div className="modal_error_text">
                                    Selecione o motivo do cancelamento!
                                </div>
                                <Grid container spacing={24}>
                                    <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                        &nbsp;
                                    </Grid>
                                    <Grid item style={this.styles.col} xs={12} sm={12} md={10} lg={10}>
                                        <Input
                                            id='cancelation'
                                            style={{ width: '46%', margin: '10px auto 0 auto' }}
                                            type="select"
                                            className="form-control"
                                            defaultValue={this.state.cancellationId}
                                            onChange={this.chooseCancelation.bind(this, 'cancelation')}
                                        >
                                            <option value="">Motivo do cancelamento</option>
                                            {this.state.cancellationsList.map((item, index) =>
                                                <option key={index} value={item.id}>{item.code + ' - ' + item.name}</option>
                                            )}
                                        </Input>
                                    </Grid>
                                    <Grid item style={this.styles.col} xs={12} sm={12} md={1} lg={1}>
                                        &nbsp;
                            </Grid>
                                </Grid>
                                    <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center', gap: '10px' }}>
                                        <button
                                            type="button"
                                            onClick={this.closeInclusion.bind(this)}
                                            style={{ 
                                            ...Styles.buttonCancel, 
                                            backgroundColor: Colors.textLight, // Usando cinza para cancelar
                                            textTransform: 'none' 
                                            }}
                                        >
                                            Cancelar
                                        </button>
                                        <button
                                            type="button"
                                            onClick={this.cancelarInclusao.bind(this)}
                                            style={{ 
                                            ...Styles.buttonSuccess, 
                                            fontWeight: 'bold', 
                                            textTransform: 'none' 
                                            }}
                                        >
                                            Sim
                                        </button>
                                    </div>                            

                        </div>
                        ):(
                                <div className="modal_error_text">
                                    Estamos cancelando sua proposta aguarde....!
                                </div>
                        )}

                </Dialog>

                <Dialog
                    open={this.state.confirmationS4E}
                    onRequestClose={this.closeS4E.bind(this)}
                    modal={true}
                >
                    <div className="modal_error_text">
                        Estamos enviando sua proposta para o S4E, aguarde... <br/>Isso pode levar alguns minutos!
                    </div>
                </Dialog>


            </div>
        );

    }

}

List.propTypes = {
    table: PropTypes.string
};

export default List;



/** WEBPACK FOOTER **
 ** ./src/components/Panel/Inclusao/List.js
 **/